import type { AccountContent } from "@loot-os/design-system/templates/account/accountContent";
import type { PageTemplate } from "@loot-os/design-system/templates/contract";
import { PageTemplateView } from "@loot-os/design-system/templates/shared/PageTemplateView";

import { RequireAuth } from "../components/RequireAuth.js";
import { ShippingAddressDialog } from "../components/ShippingAddressDialog.js";
import { UsernameDialog } from "../components/UsernameDialog.js";
import { useTenant } from "../lib/tenant.js";
import { useAccountPage } from "../templates/pages/account/useAccountPage.js";
import { storefrontTemplateOf } from "../templates/registry.js";

export function AccountPage() {
  const { config } = useTenant();
  return (
    <RequireAuth>
      <AccountView template={storefrontTemplateOf(config).account} />
    </RequireAuth>
  );
}

/**
 * The Account page (settings, history), laid out by `template`, with the dialogs its
 * actions open over it. The parity suite renders this under every template.
 */
export function AccountView({ template }: { template: PageTemplate<AccountContent> }) {
  const { content, dialogs } = useAccountPage();
  const { username, address } = dialogs;
  return (
    <>
      <PageTemplateView template={template} content={content} />
      {address.open && (
        <ShippingAddressDialog
          open={address.open}
          onOpenChange={address.setOpen}
          address={address.address}
          destinations={address.destinations}
        />
      )}
      {username?.open && (
        <UsernameDialog
          open={username.open}
          onOpenChange={username.setOpen}
          username={username.username}
        />
      )}
    </>
  );
}
